























import { Component, Vue } from 'vue-property-decorator';

import { ErrorMessage } from '@/common/errors';
import { DailyReport } from '@/models/dailyReport.model';
import EntryForm from '@/pages/index/components/EntryForm.vue';
import IndexPageEditDialog from '@/pages/index/pages/index/components/IndexPageEditDialog.vue';
import { DailyReportStore, EDITOR_WIDTH } from '@/store/dailyReport';
import { LocationStore } from '@/store/location';

@Component({
  components: {
    ErrorMessage,
    EntryForm,
    IndexPageEditDialog,
  },
})
export default class NewEntryPage extends Vue {

  @DailyReportStore.Bind.Action create!: DailyReportStore.Action<'create'>;
  @LocationStore.Bind.State fuels!: LocationStore.State<'fuels'>;
  @DailyReportStore.Bind.Action makeDefaultDailyReportForFuel!: DailyReportStore.Action<'makeDefaultDailyReportForFuel'>;

  EDITOR_WIDTH = EDITOR_WIDTH;
  error = '';
  isReady = false;
  isSaving = false;
  reports: DailyReport[] = [];

  async created() {
    const promises = this.fuels.map(fuel => this.makeDefaultDailyReportForFuel(fuel));
    this.reports = await Promise.all(promises);
    this.isReady = true;
  }

  cancel() {
    this.goBack();
  }

  async submit() {
    this.error = '';
    this.isSaving = true;

    try {
      await this.create({ reports: this.reports });
      this.goBack();
    }
    catch (ex) {
      this.error = ex;
    }
    finally {
      this.isSaving = false;
    }
  }

  private goBack() {
    this.$router.go(-1);
  }

}
